<template>
	<div class="template-helper-wrapper">
		<div class="template-helper">
			<div class="template-helper__wrapper">
				<div>
					<div class="template-helper-header">Переменные</div>
					<div class="template-helper__variable">
						<span class="inline-code" v-copy>[id]</span> - номер заяки
					</div>
					<div class="template-helper__variable">
						<span class="inline-code" v-copy>[site_url]</span> - URL сайта
					</div>
					<div class="template-helper__variable">
						<span class="inline-code" v-copy>[region]</span> - регион
					</div>
					<div class="template-helper__variable">
						<span class="inline-code" v-copy>[city]</span> - город
					</div>
					<div class="template-helper__variable">
						<span class="inline-code" v-copy>[site_name]</span> - название сайта
					</div>
					<div class="template-helper__variable">
						<span class="inline-code" v-copy>[url]</span> - страница, с которой была оформлена заявка
					</div>
					<div class="template-helper__variable" v-for="(val, index) in settings.form_fields" :key="index"
							v-if="!!fieldsName[val.type]">
						<span class="inline-code" v-copy>[{{val.type}}]</span> - {{fieldsName[val.type]}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import copy from '../../../components/selectcopy'

const fieldsName = {
	text_name: 'имя',
	time: 'время для звонка',
	topic: 'тема обращения',
	tel: 'телефон',
	email: 'e-mail',
	comment: 'комментарий'
}

export default {
	props: ['settings'],
	data() {
		return {
			fieldsName
		}
	},
	directives: {
		copy
	}
}
</script>
<style scoped>
.template-helper-wrapper {
	position: relative;
}

.template-helper {
	right: 0;
	width: 66%;
	box-sizing: border-box;
	padding: 0 5px;
	top: -5px;
	bottom: 0;
	overflow: hidden;
}

.is-wa2 .template-helper {
  width: auto;
}

.template-helper__wrapper {
	background: #f7f7f7;
	box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
	color: #aaaaaa;
	font-size: 0.8em;
	border: 1px solid #efefef;
	padding: 0 15px 15px;
}

.template-helper-header {
	font-size: 1.2em;
	font-weight: bold;
	color: #777777;
	margin-top: 15px;
}

.template-helper__variable {
	margin: 5px 0;
	font-family: 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', 'Liberation Sans', Arial, sans-serif;
}

.inline-code {
	color: #777777;
	display: inline-block;
	padding: 3px;
	background: #eeeeee;
	border: 1px solid #eeeeee;
	border-radius: 3px;
}

.inline-code:hover {
	border-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/webpack/vue/settings/components/notification/HotVar.vue